import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { isEmpty, filter } from 'lodash';
import api from 'config/api';
import requester from 'utils/requester';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import urlHelper from 'helpers/urlhelper';

export const KEY = 'USE_LOAD_EPG_DYNAMIC_CATEGORIES';

const apiCall = async ({ isLoggedIn }) => {
  const categoriesEndpoint = urlHelper.getAuthorizedEndpointUrl(api.endpoints.dynamicEPGCategories, isLoggedIn);

  const categories = await requester({
    method: 'get',
    url: `${api.host}${categoriesEndpoint}`,
    params: { type: 'GLOBAL' },
  });

  return filter(categories, (category) => !isEmpty(category.channelIds));
};

const useLoadEPGDynamicCategories = (options) => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  return useQuery([KEY, isLoggedIn], () => apiCall({ isLoggedIn }), { ...options });
};

export default useLoadEPGDynamicCategories;
